import { combineEpics, Epic } from "redux-observable";

import * as authEpics from "./module/auth/authEpics";
import * as commonEpics from "./module/common/commonEpics";
import * as countryEpics from "./module/country/countryEpics";
import * as userEpics from "./module/user/userEpics";
import * as tagEpics from "./module/tag/tagEpics";
import * as venueEpics from "./module/venue/venueEpics";
import * as userProfileEpics from "./module/user-profile/userProfileEpics";
import * as organizationEpics from "./module/organization/organizationEpics";
import * as userMonitorEventEpics from "./module/user-monitor-event/userMonitorEventEpics";
import * as beaconEpics from "./module/beacon/beaconEpics";
import * as promotionCodeEpics from "./module/promotion-code/promotionCodeEpics";
import * as partnershipEpics from "./module/partnership/partnershipEpics";
import * as emailTemplateEpics from "./module/email-template/emailTemplateEpics";
import * as adminUserEpics from "./module/admin-user/adminUserEpics";
import * as memberCardPoolsEpic from "./module/member-card-pool/memberCardPoolEpics";
import * as shopEpics from "./module/shop/shopEpics";
import { catchError } from "rxjs/operators";

const combinedEpics = combineEpics(
  authEpics.authEpic,
  authEpics.loginOnAppInitEpic,
  authEpics.selectOrganizationEpic,
  authEpics.logoutEpic,
  commonEpics.showToastEpic,
  countryEpics.countryListEpic,
  tagEpics.tagForOrganization,
  userEpics.userEpic,
  userEpics.filterUsersEpic,
  userEpics.resetUserFiltersEpic,
  userEpics.approveUserEpic,
  userEpics.denyUserEpic,
  userEpics.loadFiltersOnAppStartup,
  userEpics.autocompleteUserEpic,
  venueEpics.getVenueForEditEpic,
  venueEpics.updateVenueEpic,
  venueEpics.insertVenueEpic,
  venueEpics.deleteVenueImageEpic,
  userProfileEpics.closeUpsertUserVoucherPopupOnSuccess,
  organizationEpics.updateUISettings,
  userMonitorEventEpics.userEpic,
  beaconEpics.beaconsForOrganization,
  promotionCodeEpics.promotionCodesListEpic,
  partnershipEpics.partnershipListEpic,
  memberCardPoolsEpic.memberCardPoolsEpic,
  emailTemplateEpics.emailTemplateListEpic,
  emailTemplateEpics.sendTestEmailTemplateEpic,
  adminUserEpics.adminUserListEpic,
  adminUserEpics.upsertAdminUser,
  adminUserEpics.getAdminUserEpic,
  adminUserEpics.modifyRoleEpic,
  shopEpics.shopListEpic,
  shopEpics.getShopEpic,
  shopEpics.getShopTimeslotsEpic,
  shopEpics.updateShopTimeslotEpic,
  shopEpics.upsertShopEpic,
  shopEpics.getProductCategoryListEpic,
  shopEpics.getProductCategoryEpic,
  shopEpics.upsertProductCategoryEpic,
  shopEpics.updateProductCategoryOrderEpic,
  shopEpics.upsertHomepageEpic,
  shopEpics.homepageList,
  shopEpics.deleteHomepage,
  shopEpics.listUnassignedNewsEpic,
  shopEpics.getOrderEpic,
  shopEpics.listOrdersEpic,
  shopEpics.refundOrderEpic
);

const rootEpic: Epic = (action$, store$, dependencies) =>
  combinedEpics(action$, store$, dependencies).pipe(
    catchError((error, source) => {
      console.error(error);
      return source;
    })
  );

export default rootEpic;
